import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTelegram, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <FooterContainer>
            <FooterContent>
                <Section>
                    <SectionTitle>Contact Me</SectionTitle>
                    <ContactInfo>
                        <p>Email: xadasad67@gmail.com</p>
                        <p>Phone: +998994878460</p>
                    </ContactInfo>
                </Section>
                <hr className="hr-block"/>
                <Section>
                    <SectionTitle>Follow Me</SectionTitle>
                    <SocialIcons>

                        <a href="https://t.me/nerdbek" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faTelegram} size="2x" />
                        </a>
                        <a href="https://instagram.com/leomessi/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faInstagram} size="2x" />
                        </a>
                        <a href="https://www.linkedin.com/in/asad-xad-1bb8a624a/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} size="2x" />
                        </a>
                    </SocialIcons>
                </Section>
                <hr className="hr-block"/>

                <Section>
                    <SectionTitle>Quick Links</SectionTitle>
                    <NavLinks>
                        <a href="/">Home</a>
                        <a href="/about">About</a>
                        <a href="/services">Services</a>
                        <a href="/contact">Contact</a>
                    </NavLinks>
                </Section>
            </FooterContent>
            <FooterBottom>
                <p>© {new Date().getFullYear()} Asad's Portfolio. All rights reserved.I think.</p>
            </FooterBottom>
        </FooterContainer>
    );
};

const FooterContainer = styled.footer`
  background-color: #000;
  color: #03ff2c;
  padding: 40px 20px;
  text-align: center;
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  
  @media (max-width: 600px) {
    padding: 20px 10px;
  }
  .hr-block{
    display: none;
    color: #0fff03;
    width: 100%;
    border: 0.5px  solid #0fff03;
  }
  @media (max-width: 678px){
   .hr-block{
     display: block;
   }
  }
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 678px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Section = styled.div`
  flex: 1;
  min-width: 200px;
`;

const SectionTitle = styled.h3`
  font-size: 1.5em;
  font-family: Consolas, monospace;
  margin-bottom: 10px;
  
  @media (max-width: 678px){
        font-size:1.1rem !important;
  }
`;

const ContactInfo = styled.div`
  font-family: Consolas, monospace;
  text-align: left;

  @media (max-width: 600px) {
    text-align: center;
  }
  @media (max-width: 678px){
p{
  font-size:0.9rem !important;

}  }
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;

  a {
    color: #03ff2c;
    transition: color 0.3s;

    &:hover {
      color: #fff;
    }
  }
  @media (max-width: 678px){
    a{
      font-size:1rem !important;

    }  }
`;

const NavLinks = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;

  a {
    color: #03ff2c;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: #fff;
    }
  }

  @media (max-width: 678px) {
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    a {
      font-size: 0.9rem !important;

    }
  }
`;

const FooterBottom = styled.div`
  font-family: Consolas, monospace;
  border-top: 1px solid #03ff2c;
  padding-top: 20px;
`;

export default Footer;
